var _path, _path2, _circle, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVarunaIconPHF(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    fill: "currentcolor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M445.59,3.62H54.49A50.62,50.62,0,0,0,4.23,53.88V445a50.62,50.62,0,0,0,50.26,50.26h391.1A50.61,50.61,0,0,0,495.85,445V53.88A50.11,50.11,0,0,0,445.59,3.62ZM323.86,111.21h-2.35a7.13,7.13,0,0,1,.78,3.93v245c0,.79-3.14,65.18-71.46,65.18-54.19,0-71.47-44-73-66.75V111.21H177a10.21,10.21,0,0,1,0-20.42H323.86a10.21,10.21,0,0,1,0,20.42Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M199,112.78v245c.79,6.28,6.29,47.12,52.62,47.12,47.12,0,50.26-40.06,50.26-44.77v-245a7.06,7.06,0,0,1,.79-3.93H199Zm36.13,44a18.85,18.85,0,1,1-18.85,18.85A19.11,19.11,0,0,1,235.12,156.76Zm-26.7,197.9V214.09a7.86,7.86,0,0,1,7.85-7.85H283a7.87,7.87,0,0,1,7.86,7.85V357a5.89,5.89,0,0,1-.79,3.14c-.78,1.57-11.78,29.84-41.62,29.84-30.63,0-40.05-31.41-40.05-33Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 240.62,
    cy: 289.48,
    r: 11.78,
    transform: "translate(-43.26 42.28) rotate(-9.22)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M257.11,265.92A18.61,18.61,0,0,0,276,247.07a18.85,18.85,0,0,0-37.7,0A18.6,18.6,0,0,0,257.11,265.92Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVarunaIconPHF);
export default __webpack_public_path__ + "static/media/Varuna_Icon_pH_F.9111dd8b.svg";
export { ForwardRef as ReactComponent };